import {
    Button,
    Card,
    HorizontalContainer,
    VerticalContainer,
} from '@/components';
import { R } from '@/features/pfaPhysiotherapy/resources/PfaPhysiotherapyResources.resx';
import { PfaLogoIcon } from '@/components/Icons';

type LandingPageProps = {
    onNext: () => void;
};

export const LandingPage = ({ onNext }: LandingPageProps) => {
    return (
        <VerticalContainer spacing="none" className="items-center">
            <HorizontalContainer className="ns:-mb-6 mb-4">
                <img
                    className="relative z-10 -mr-8 inline-block h-[242px] w-[124px]"
                    src="/images/icons_shape/physiotherapist.svg"
                    alt=""
                />
                <img
                    className="z-0 inline-block h-[228px] w-[116px]"
                    src="/images/icons_shape/gp-female.svg"
                    alt=""
                />
            </HorizontalContainer>

            <Card alwaysCard={false} className="z-10">
                <VerticalContainer spacing="md">
                    <PfaLogoIcon className="mb-2 w-24" />
                    <h2>{R.ApplyForOnlinePhysiotherapy}</h2>
                    <div className="whitespace-pre-line">
                        {R.ApplyForOnlinePhysiotherapyDescription}
                    </div>
                </VerticalContainer>

                <div className="flex justify-end">
                    <Button variant="primary" onClick={onNext}>
                        {R.Next}
                    </Button>
                </div>
            </Card>
        </VerticalContainer>
    );
};
